export { default as Code } from './code';

export { default as CodeBlock } from './code-block';

export type {
	CodeBlockProps,
	CodeProps,
	SupportedLanguages,
	LanguageAlias,
	Language,
} from './types';

export { SUPPORTED_LANGUAGES } from './constants';
